import { Box, Button, CircularProgress, Grid, Hidden, IconButton, useTheme } from '@material-ui/core';
import { DeleteOutlineTwoTone, Warning } from '@material-ui/icons';
import {
  CheckedCircleIcon,
  CustomVideoPlayer,
  OtherImagesIcon,
  PhotoEditor,
  StyledTooltip,
  Typography,
} from '@room-match/shared-ui-components';
import AsyncPhotoEditorV2 from 'components/AsyncPhotoEditorV2/AsyncPhotoEditorV2';
import React, { useEffect, useRef, useState } from 'react';
import { AiOutlineUpload } from 'react-icons/ai';
import MediaBinModal from 'shared/components/MediaBinModal/MediaBinModal';
import { NO_IMAGE_PLACEHOLDER_URL } from 'shared/constants/ASSETS_URL';
import { IAttachAuditionMedia, IAuditionMedia } from 'shared/interfaces/IAudition';
import IMedia from 'shared/interfaces/IMedia';
import { IOutput } from 'shared/interfaces/IProfile';
import { IOnProgress } from 'shared/interfaces/utils/IAxios';
import { uploadService } from 'shared/services/uploadService';
import AudioItem from './MediaItems/AudioItem';
import FIleItem from './MediaItems/FIleItem';
import ImageItem from './MediaItems/ImageItem';
import { ImageElement, ImageItemCont, VideoItemCont } from './MediaItems/MediaItem.styles';
import VideoItem from './MediaItems/VideoItem';
import { MultipleItem, MultipleItemCont, ProgressOverlay, useStyles } from './SelfTapes.styles';
import { SizeCardModal } from './SizeCardModal';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { COLORS } from 'shared/constants/COLORS';
const {
  DARK_SECONDARY_BUTTON_BORDER,
  ERROR_BUTTON_BACKGROUND,
  LIGHT_BUTTON_BORDER,
  LIGHT_GREEN_ICON,
  PRIMARY_ICON,
  WARNING_ICON,
} = COLORS;

interface Props {
  label: string;
  i: any;
  type: 'Image' | 'Video' | 'Audio' | 'File' | 'Other Image';
  bindMedia: (data: IAttachAuditionMedia) => void;
  deleteMedia: (id: string) => void;
  completed: boolean;
  media?: IAuditionMedia;
  tag_list: string[];
  hasImage: boolean;
  hasVideo: boolean;
  hasAudio: boolean;
  req?: boolean;
  multiple?: boolean;
  addTag?: (tag: string) => void;
  removeTag?: (tag: string) => void;
  sort: number;
  invalidFileFormat: (type: 'video' | 'audio' | 'image' | 'document' | 'invalid_image') => void;
  invalidImageOrientation: VoidFunction;
}
const { uploadMedia } = uploadService();

const UploadingItem: React.FC<Props> = ({
  label,
  i,
  type,
  bindMedia,
  completed: uploaded,
  media,
  deleteMedia,
  tag_list,
  hasImage,
  hasVideo,
  hasAudio,
  req,
  multiple,
  addTag,
  removeTag,
  sort,
  invalidFileFormat: invalidFile,
  invalidImageOrientation,
}) => {
  const theme = useTheme();
  const { mutateAsync: uploadMediaMutateAsync } = uploadMedia();
  const [medias, setmedias] = useState<IMedia[]>([]);
  const [uploading, setuploading] = useState(false);
  const [showMedia, setShowMedia] = useState(false);
  const [completed, setCompleted] = useState(uploaded);
  const [showEditor, setshowEditor] = useState(false);
  const [progress, setprogress] = useState(100);
  const [file, setfile] = useState<File>();
  const classes = useStyles();
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [sizeCardModalOpen, setsizeCardModalOpen] = useState(false);
  const [deleting, setdeleting] = useState(false);
  const [thumbnail, setthumbnail] = useState('');
  const [tagToSet, setTagToSet] = useState<string[]>([]);
  const [portrait, setportrait] = useState(false);
  const [invalidOrientation, setInvalidOrientation] = useState(false);

  const onProgres: IOnProgress = (progress: number) => {
    setprogress(progress);
  };

  useEffect(() => {
    setCompleted(uploaded);
  }, [uploaded]);

  const processImage = (image: File) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => {
        const img = new Image();
        img.src = e.target?.result as string;
        img.onload = () => {
          resolve(img);
        };
        img.onerror = (err) => {
          invalidFile('invalid_image');
          setuploading(false);
        };
      };
      reader.readAsDataURL(image);
    });
  };

  const handleUpload = async (data: File | any, image: IOutput[]) => {
    //pass to parent the taglist to render new add button
    if (addTag) addTag(tagToSet.length ? tagToSet.toString() : tag_list.toString());

    setsizeCardModalOpen(false);
    setuploading(true);
    const formData = new FormData();

    if (label === 'Audition Selfie') {
      const {
        attachment,
        file_name,
        file_width,
        file_height,
        file_type,
        file_size,
        tag_list,
        attachment_size,
        modified_metadata,
        modified_attachment,
      } = image[0];

      if (parseInt(file_width) < parseInt(file_height)) {
        invalidImageOrientation();
        setInvalidOrientation(true);
      } else {
        setInvalidOrientation(false);
      }

      formData.set('attachment', attachment);
      formData.set('modified_attachment', modified_attachment as any);
      formData.set('modified_metadata', JSON.stringify(modified_metadata) as any);
      formData.set('attachment_size', attachment_size ? attachment_size.toString() : '');
      formData.append('file_name', file_name);
      formData.append('file_type', file_type);
      formData.set('file_size', file_size);
      formData.set('file_height', file_height);
      formData.set('file_width', file_width);
      formData.append('tag_list', tag_list);
      // formData.append('media_bin', 'true');
      formData.append('file_type', 'image');
    } else if (type === 'Image' || type === 'Other Image') {
      //check if image is .avif
      if (data.type === 'image/avif') {
        setuploading(false);
        return invalidFile('invalid_image');
      }

      //check if image is portrait using File height and width
      await processImage(data).then((img: any) => {
        formData.set('file_height', img.height);
        formData.set('file_width', img.width);
        if (label === 'Audition Selfie') {
          if (img.width < img.height) {
            invalidImageOrientation();
            setInvalidOrientation(true);
          } else {
            setInvalidOrientation(false);
          }
        }
      });
      formData.set('attachment', data);
      formData.append('file_name', data.name);
      formData.append('file_type', 'image');
      formData.set('file_size', data.size.toString());
    } else {
      formData.set('attachment', data);
      formData.append('file_name', data.name);
      formData.append('file_type', `${type === 'Video' ? 'video' : type === 'Audio' ? 'audio' : 'document'}`);
      formData.set('file_size', data.size.toString());
    }

    const uploadedPhoto = await uploadMediaMutateAsync({ formData, onProgres });

    if (uploadedPhoto) {
      setdeleting(false);
      setuploading(false);
      setCompleted(true);
      //pass to parent the taglist to render new add button
      if (removeTag) removeTag(tagToSet.length ? tagToSet.toString() : tag_list.toString());
      bindMedia({
        medium_id: uploadedPhoto.data.id,
        tag_list: tagToSet.length ? tagToSet : tag_list,
        sort,
      });
      setthumbnail(
        `https://px-public-dev.s3.us-west-1.amazonaws.com/${
          uploadedPhoto.data.attributes.attachment_url.split('/')[3]?.split('?')[0]
        }.0000000.jpg`,
      );
    } else {
      console.error('Uploading Failed');
    }

    if (inputRef.current) inputRef.current.value = '';
  };

  const progressOverlay = () => (
    <ProgressOverlay>
      <svg width="0" height="0">
        <linearGradient id="linearColors" x1="0" y1="0" x2="1" y2="1">
          <stop offset="20%" stopColor={PRIMARY_ICON} />
          <stop offset="90%" stopColor={PRIMARY_ICON} />
        </linearGradient>
      </svg>
      {progress === 100 ? (
        <CircularProgress thickness={3} classes={{ circle: classes.circle }} />
      ) : (
        <>
          <CircularProgress thickness={3} variant="determinate" value={progress} classes={{ circle: classes.circle }} />
          <p style={{ position: 'absolute', fontSize: 12 }}>{`${Math.round(progress)}%`}</p>
        </>
      )}
    </ProgressOverlay>
  );

  const handleAdd = () => {
    if (inputRef.current) inputRef.current?.click();
  };

  const setTag = (tag: string) => {
    setTagToSet([tag, type]);
  };

  const renderMedia = () => {
    switch (type) {
      case 'Audio':
        return (
          <AudioItem
            src={media?.attributes.attachment || ''}
            fileName={media?.attributes.medium.data.attributes.file_name || ''}
          />
        );
      case 'Video':
        return (
          <VideoItem
            src={media?.attributes.attachment || ''}
            mediaId={media?.attributes.medium.data.id}
            thumbnail={thumbnail}
          />
        );
      case 'Image':
      case 'Other Image':
        return <ImageItem src={media?.attributes.attachment || ''} setPortrait={() => setportrait(true)} />;
      case 'File':
        return (
          <FIleItem
            src={media?.attributes.attachment || ''}
            fileName={media?.attributes.medium.data.attributes.file_name || ''}
          />
        );
      default:
        return (
          <Box style={{ display: 'flex', flexDirection: 'column', margin: 10 }}>
            <Typography>Media Uploaded</Typography>
            <Typography color="darkGrey" style={{ fontStyle: 'italic' }}>
              Preview not Available
            </Typography>
          </Box>
        );
    }
  };

  const addMedia = (media: IMedia[]) => {
    setuploading(true);
    setsizeCardModalOpen(false);
    bindMedia({
      medium_id: media[0].id,
      tag_list: tagToSet.length ? tagToSet : tag_list,
      sort,
    });
    setTimeout(() => {
      setdeleting(false);
      setuploading(false);
    }, 1000);
  };

  const handleChange = () => {
    setdeleting(true);
    deleteMedia(tag_list.toString().toLocaleLowerCase());
    setTimeout(() => {
      setdeleting(false);
    }, 2000);
  };

  const renderFallBackMedia = () => {
    switch (type) {
      case 'Image':
        return (
          <ImageItemCont>
            <ImageElement src={file ? URL.createObjectURL(file as any) : NO_IMAGE_PLACEHOLDER_URL} />
          </ImageItemCont>
        );

      case 'Video':
        return (
          <VideoItemCont>
            <div style={{ flex: 1, height: 214, borderRadius: 10 }}>
              {file ? (
                <CustomVideoPlayer
                  classes={{ root: 'profile-video-item', videoPlayer: '', icon: '' }}
                  url={URL.createObjectURL(file as any)}
                />
              ) : (
                <React.Fragment />
              )}
            </div>
          </VideoItemCont>
        );
      default:
        return (
          <>
            <Typography>Media Uploaded</Typography>
            <Typography color="darkGrey" style={{ fontStyle: 'italic' }}>
              Preview not Available
            </Typography>
          </>
        );
    }
  };

  const invalidFileFormat = (type: 'video' | 'audio' | 'image' | 'document') => {
    if (inputRef.current) inputRef.current.value = '';
    invalidFile(type);
  };

  useEffect(() => {
    if (!media || label !== 'Audition Selfie') return;
    //check if image is portrait using media height and width
    if (media?.attributes.medium.data.attributes.file_width < media?.attributes.medium.data.attributes.file_height) {
      setInvalidOrientation(true);
    }
  }, [media, label]);

  const showInstruction = Boolean(type !== 'Audio') && Boolean(type !== 'File') && Boolean(label !== 'Full Body');

  const instruction = () => (
    <div style={{ display: 'flex', marginRight: 10, flex: 1 }}>
      <Warning style={{ color: WARNING_ICON, marginRight: 5, alignSelf: 'center' }} />
      <Hidden smDown>
        <CustomTypography fontSize={14} fontWeight={500}>
          {invalidOrientation && label === 'Audition Selfie'
            ? 'Wrong Image Format'
            : 'Please follow the instructions above'}
        </CustomTypography>
      </Hidden>
      <Hidden mdUp>
        <CustomTypography fontSize={14} fontWeight={500}>
          {invalidOrientation && label === 'Audition Selfie' ? 'WARNING' : 'Read above'}
        </CustomTypography>
      </Hidden>
    </div>
  );
  return (
    <>
      {req ? (
        multiple ? (
          <MultipleItemCont item>
            <MultipleItem disabled={uploading} onClick={() => setsizeCardModalOpen(true)}>
              {uploading ? (
                progressOverlay()
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                  <AiOutlineUpload
                    style={{
                      color: PRIMARY_ICON,
                      fontSize: 35,
                      marginBottom: 5,
                    }}
                  />
                  <CustomTypography fontSize={16}>{type === 'File' ? 'Add File' : 'Add Media'} </CustomTypography>
                </div>
              )}
            </MultipleItem>
          </MultipleItemCont>
        ) : (
          <>
            {media ? (
              <MultipleItemCont item style={{ marginLeft: 0 }}>
                {renderMedia()}
                <StyledTooltip title={label} classes={{ tooltip: classes.toolTipStyle }}>
                  <div style={{ display: 'flex', position: 'relative', marginBottom: 10 }}>
                    <CustomTypography
                      fontSize={16}
                      fontWeight={700}
                      style={{
                        marginLeft: 45,
                        marginTop: -5,
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        maxWidth: portrait ? 110 : 300,
                      }}
                    >
                      {label}
                    </CustomTypography>
                    <IconButton
                      disabled={deleting}
                      onClick={handleChange}
                      style={{
                        position: 'absolute',
                        right: 0,
                        top: -5,
                        padding: 2,
                        background: deleting
                          ? theme.palette.type === 'dark'
                            ? DARK_SECONDARY_BUTTON_BORDER
                            : LIGHT_BUTTON_BORDER
                          : ERROR_BUTTON_BACKGROUND,
                      }}
                    >
                      {deleting ? (
                        <CircularProgress style={{ width: 20, height: 20 }} />
                      ) : (
                        <DeleteOutlineTwoTone style={{ color: 'white' }} />
                      )}{' '}
                    </IconButton>
                  </div>
                </StyledTooltip>
              </MultipleItemCont>
            ) : (
              <MultipleItemCont item>
                <MultipleItem required disabled={uploading} onClick={() => setsizeCardModalOpen(true)}>
                  {uploading ? (
                    progressOverlay()
                  ) : (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <AiOutlineUpload
                        style={{
                          color: PRIMARY_ICON,
                          fontSize: 35,
                          marginBottom: 5,
                        }}
                      />
                      <CustomTypography fontSize={16}>Add Media</CustomTypography>
                    </div>
                  )}
                </MultipleItem>
                <StyledTooltip
                  title={label}
                  placement="top"
                  classes={{ tooltip: classes.toolTipStyle }}
                  PopperProps={{ style: { marginBottom: -10 } }}
                >
                  <div>
                    <CustomTypography
                      fontSize={16}
                      fontWeight={700}
                      style={{
                        marginBottom: 10,
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        maxWidth: 330,
                      }}
                    >
                      {label}
                    </CustomTypography>
                  </div>
                </StyledTooltip>
              </MultipleItemCont>
            )}
          </>
        )
      ) : (
        <>
          <Grid item className={classes.cardItem}>
            <Grid item>{label === 'Other Image' ? <OtherImagesIcon /> : i.icon} </Grid>
            <Grid item style={{ flex: 1 }}>
              <CustomTypography fontSize={15} fontWeight={600}>
                {label}
              </CustomTypography>
              <CustomTypography fontSize={14} style={{ marginTop: -5 }}>
                {i.info}
              </CustomTypography>
            </Grid>
            {showInstruction ? instruction() : <React.Fragment />}

            <Grid item className={classes.buttonContainer}>
              {uploading ? (
                progressOverlay()
              ) : completed ? (
                <Box style={{ display: 'flex' }}>
                  <CheckedCircleIcon htmlColor={LIGHT_GREEN_ICON} />
                  <Typography className={classes.completedText} style={{ marginLeft: -5 }}>
                    Completed
                  </Typography>
                </Box>
              ) : (
                <Button
                  variant="outlined"
                  fullWidth
                  className={classes.buttonCls}
                  onClick={() =>
                    label === 'Audition Selfie' || label === 'Full Body' ? handleAdd() : setsizeCardModalOpen(true)
                  }
                >
                  ADD
                </Button>
              )}
            </Grid>
          </Grid>
          {media && (
            <Box className={classes.deleteCont}>
              {renderMedia()}
              {!req && completed && (
                <Button className={classes.deleteButton} onClick={handleChange} disabled={deleting}>
                  {deleting ? <CircularProgress style={{ width: 20, height: 20 }} /> : 'DELETE'}
                </Button>
              )}
            </Box>
          )}
          {!media && completed ? (
            <Box className={classes.deleteCont} style={{ display: 'flex', flexDirection: 'column' }}>
              {renderFallBackMedia()}
            </Box>
          ) : (
            <React.Fragment />
          )}
        </>
      )}
      <input
        type="file"
        ref={inputRef}
        hidden
        accept={`${
          type === 'File'
            ? '.doc,.dox,.pdf,'
            : type === 'Audio'
              ? 'audio/*'
              : type === 'Image'
                ? 'image/*'
                : type === 'Other Image'
                  ? 'image/*'
                  : type === 'Video'
                    ? 'video/*, .mkv'
                    : ''
        }`}
        onChange={(e) => {
          if (e.target.files?.length) {
            const fileType = e.target.files[0].type.split('/')[0];
            //clear input value

            if ((type === 'Image' || type === 'Other Image') && fileType !== 'image') {
              invalidFileFormat('image');
              return;
            }
            if (type === 'Video' && fileType !== 'video') {
              invalidFileFormat('video');
              return;
            }
            if (type === 'Audio' && fileType !== 'audio') {
              invalidFileFormat('audio');
              return;
            }
            if (type === 'File' && fileType !== 'application') {
              invalidFileFormat('document');
              return;
            }

            setfile(e.target.files[0]);
            if (label === 'Audition Selfie') {
              setshowEditor(true);
            } else {
              handleUpload(e.target.files[0], []);
            }
            if (inputRef.current) inputRef.current.value = '';
          }
        }}
      />
      {showMedia ? (
        label === 'Audition Selfie' ? (
          <MediaBinModal
            imageOrientation={'landscape'}
            single
            showOnly={type === 'Audio' ? ['audio'] : type === 'Video' ? ['video'] : ['image']}
            selected={medias}
            show={showMedia}
            close={() => setShowMedia(false)}
            setSelected={addMedia}
          />
        ) : (
          <MediaBinModal
            single
            showOnly={type === 'Audio' ? ['audio'] : type === 'Video' ? ['video'] : ['image']}
            selected={medias}
            show={showMedia}
            close={() => setShowMedia(false)}
            setSelected={addMedia}
          />
        )
      ) : (
        <React.Fragment />
      )}
      {showEditor &&
        file &&
        (label === 'Audition Selfie' ? (
          <AsyncPhotoEditorV2
            {...{
              patchMultipleMediaAsync: () => {},
              patchMediaTagsAsync: () => {},
              uploadMediaMutateAsync,
              updateSkillAsync: () => {},
            }}
            setFixDefaultRatio="landscape"
            variant="simple"
            featureEnableRenderSkillTags={true}
            enableUndo={true}
            skillsData={{
              id: '',
              type: 'skill',
              attributes: {
                id: '',
                skills: [],
              },
            }}
            mediaData={[]}
            mediaTags={[]}
            show={showEditor}
            images={[file]}
            handleOnSave={(image: any) => {
              setshowEditor(false);
              handleUpload([], [image]);
            }}
            close={() => setshowEditor(false)}
            onSuccessImageUpdate={() => {}}
            onSuccessImageUpload={() => {}}
          />
        ) : (
          <PhotoEditor
            selfTapes
            show={showEditor}
            images={[file]}
            close={() => {
              setshowEditor(false);
              if (inputRef.current) inputRef.current.value = '';
            }}
            output={(img) => handleUpload([], img)}
          />
        ))}

      <SizeCardModal
        setTag={setTag}
        type={type}
        onUpload={handleAdd}
        open={sizeCardModalOpen}
        onClose={() => setsizeCardModalOpen(false)}
        label={label}
        info={i.info}
        openMediaBin={() => setShowMedia(true)}
        hasImage={hasImage}
        hasAudio={hasAudio}
        hasVideo={hasVideo}
      />
    </>
  );
};

export default UploadingItem;
